import { render, staticRenderFns } from "./TaxOfficerBoard.vue?vue&type=template&id=954e77b6&"
import script from "./TaxOfficerBoard.vue?vue&type=script&lang=js&"
export * from "./TaxOfficerBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports